import Cookie from "js-cookie";
import { useJwt } from "react-jwt";

export const removeCookies = () => {
    /**
     * Clears all data from cookie and localStorage!
     */
    Cookie.remove("colleagueID");
    Cookie.remove("allInfo");
    Cookie.remove("nameID")
    Cookie.remove("nameIdFormat")    
   /* if (removeRedirectTo) {
      Cookie.remove("redirectTo");
    } */
    Cookie.remove("env_variable")
    Cookie.remove("token");
    Cookie.remove("X_TKN");
    localStorage.clear();
};


/**
 * Logout from the application.
 * Redirect to base url if we don't have the params for location
 */
 export const logout = (idleLogout) => {
  //alert("we are good")
    const nameid = Cookie.get("nameId");
    const nameidformat = Cookie.get("nameIdFormat");
    const sessionindex = Cookie.get("sessionIndex");
    removeCookies();
    if (idleLogout) {
      console.log("Attempting to logout for expiry!!!")
      window.location.href = `/logout/${nameid}/${nameidformat}/${sessionindex}`;
    }

    if (!nameid || !nameidformat || !sessionindex ) {
      console.log("Missing param for logout!!!")
      window.location.href = "/";
      return;
    }
    else {
      console.log("Attempting to logout!!!")
      window.location.href = `/logout/${nameid}/${nameidformat}/${sessionindex}`;
    } 
  };

  export const IsTokenValid = (X_TKN) => {
    
    /**
     * Decodes the token and checks whether the token has expired or not
     */
     const { decodedToken } = useJwt(X_TKN);
     //console.log(useJwt('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImNsYXl0b24uc2VhbHNAbWFjeXMuY29tIiwibmFtZUlEIjoiY2xheXRvbi5zZWFsc0BtYWN5cy5jb20iLCJuYW1lSURGb3JtYXQiOiJ1cm46b2FzaXM6bmFtZXM6dGM6U0FNTDoxLjE6bmFtZWlkLWZvcm1hdDplbWFpbEFkZHJlc3MiLCJjb2xsZWFndWVJRCI6IjAxMDA5OTg0IiwiaWF0IjoxNjY2MTgwMzE3LCJleHAiOjE2NjYxODEyMTd9.RNAHyqc_z4lSy_p91KZZxRoeyGQpdScd5VkzvadshTA'))
     //decodedToken = jwt.decode(X_TKN);
    // console.log("Expiration date for token ", decodedToken.exp)
    if (decodedToken && decodedToken.exp < Math.ceil(new Date().getTime() / 1000)) {
        return false;
    } else {
        return true;
    }
}  

/*export const isAuthenticated = () => {
    const { userName, email, X_TKN } = Cookie.getJSON();
    let validSession = true;
*/
    /**
     * Checks whether the required data are present in the cookie
     */ 
   /* if (!userName || !email || !X_TKN) {        
        validSession = false;
    } */
    /**
     * If all the required data are present in the cookie,
     * then check the validity of the X_TKN
     */
   /* if (!isTokenValid(X_TKN)) {
        validSession = false;
    }

    return validSession;
} */